import { render, staticRenderFns } from "./ProjectMap.vue?vue&type=template&id=804b2b5e&"
import script from "./ProjectMap.vue?vue&type=script&lang=js&"
export * from "./ProjectMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports